import React from 'react';
import { Box, Typography } from '@mui/material';
import { deviceName, deviceOs, deviceApp } from '../../../utils/CommonUtils';
import { formatDate, timeAgo } from '../../../utils/dateTime';

// Every handset the member has signed in from with the app, newest first — one entry
// per brand + model + os, folded server-side from user_tokens (GET /admin/user/:id).
const DevicesSection = ({ devices }) => {
  if (!devices?.length) return null;
  return (
    <Box sx={{ backgroundColor: '#FFFFFF', padding: { xs: '16px', lg: '24px 20px' }, borderRadius: 2, my: { xs: '0', sm: '20px' } }}>
      <Typography className="FontIvypresto" fontWeight={600} sx={{ fontSize: '20px', mb: 2, color: '#6A513E' }}>
        Devices
      </Typography>
      {devices.map((d, i) => (
        <Box key={i} sx={{ py: 1.5, borderTop: i ? '1px solid #EEE' : 'none' }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <Typography sx={{ fontWeight: 600, color: '#3C4043' }}>{deviceName(d) || 'Unknown device'}</Typography>
            {d.signedIn && (
              <Box sx={{ bgcolor: '#E6F4EA', color: '#137333', fontSize: '12px', fontWeight: 500, px: 1.25, py: 0.25, borderRadius: '8px' }}>
                Signed in
              </Box>
            )}
          </Box>
          <Typography variant="body2" color="#5F6368">
            {[deviceOs(d), deviceApp(d) && `App ${deviceApp(d)}`].filter(Boolean).join(' · ')}
          </Typography>
          <Typography variant="body2" color="#5F6368">
            Last login {timeAgo(d.lastLogin)} · First seen {formatDate(d.firstLogin)} · {d.loginCount} login{d.loginCount === 1 ? '' : 's'}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default DevicesSection;
